import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Editor } from "./components/Editor";
import { RenderedPage } from "./components/RenderedPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import Dashboard from "./pages/Dashboard";
import Client from "./app/puckpath/client"
import BlogField from "./pages/BlogField";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminDashboard from "./pages/AccessManagement";
import Clients from "./app/ForEdit/client";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditBlogField from "./pages/EditBlogField";
function App() {
  return (

    <Router>

      {/* <div>
        <h1>Welcome to the CMS App</h1>
        <ul>
          <li>
            <Link to="/editor">Go to Editor</Link>
          </li>
          <li>
            <Link to="/rendered-page">View Rendered Page</Link>
          </li>
        </ul>
        </div> */}
        <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        {/* <Route path="/editor" element={<Editor />} /> */}
        {/* <Route path="/rendered-page" element={<RenderedPage />} /> */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/blogfield" element={<ProtectedRoute><BlogField /></ProtectedRoute>} />
         <Route path="/edit/blogfield" element={<ProtectedRoute><EditBlogField /></ProtectedRoute>} />
        <Route path="/blogs/reactapp" element={<ProtectedRoute><Client path="/blogs/reactapp" /></ProtectedRoute>} />
        <Route path="/blogs/reactapp/edit" element={<ProtectedRoute><Client isEdit path="/blogs/reactapp" /></ProtectedRoute>} />
        <Route path="/blogs/reactapps" element={<ProtectedRoute><Clients path="/blogs/reactapps" /></ProtectedRoute>} />
        <Route path="/blogs/reactapps/edits" element={<ProtectedRoute><Clients isEdit path="/blogs/reactapps" /></ProtectedRoute>} />

        <Route path="/admin" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />
      </Routes>

    </Router>

  );
}

export default App;
